import { render, staticRenderFns } from "./LeadOpType.vue?vue&type=template&id=0138dcc6&scoped=true"
import script from "./LeadOpType.vue?vue&type=script&lang=ts"
export * from "./LeadOpType.vue?vue&type=script&lang=ts"
import style0 from "./LeadOpType.vue?vue&type=style&index=0&id=0138dcc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0138dcc6",
  null
  
)

export default component.exports